/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties}
 */
 /* tslint:disable */


import * as import0 from '@angular/core';
import * as import1 from '@angular/common';
import * as import2 from 'angular-confirmation-popover/dist/esm/src/focus.directive';
import * as import3 from 'angular-confirmation-popover/dist/esm/src/confirmation-popover-window.component';
import * as import4 from 'angular-confirmation-popover/dist/esm/src/confirmation-popover-window-options.provider';
const styles_ConfirmationPopoverWindowComponent:any[] = ['.popover[_ngcontent-%COMP%] {\n      display: block;\n    }\n    .bs-popover-top[_ngcontent-%COMP%]   .arrow[_ngcontent-%COMP%], .bs-popover-bottom[_ngcontent-%COMP%]   .arrow[_ngcontent-%COMP%] {\n      left: 50%;\n    }\n    .bs-popover-left[_ngcontent-%COMP%]   .arrow[_ngcontent-%COMP%], .bs-popover-right[_ngcontent-%COMP%]   .arrow[_ngcontent-%COMP%] {\n      top: 50%;\n    }\n    .btn[_ngcontent-%COMP%] {\n      transition: none;\n    }'];
export const RenderType_ConfirmationPopoverWindowComponent:import0.RendererType2 = import0.ɵcrt({
  encapsulation: 0,
  styles: styles_ConfirmationPopoverWindowComponent,
  data: {}
}
);
function View_ConfirmationPopoverWindowComponent_2(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),7,'div',[[
        'class',
        'col-xs-6 col-6'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    import0.ɵdid(139264,(null as any),0,import1.NgClass,[
      import0.IterableDiffers,
      import0.KeyValueDiffers,
      import0.ElementRef,
      import0.Renderer
    ]
    ,{
      klass: [
        0,
        'klass'
      ]
      ,
      ngClass: [
        1,
        'ngClass'
      ]

    }
    ,(null as any)),
    import0.ɵpod(['col-xs-offset-3 col-offset-3']),
    (l()(),import0.ɵted((null as any),['\n              '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),2,'button',[[
        'type',
        'button'
      ]
    ],[
      [
        8,
        'className',
        0
      ]
      ,
      [
        8,
        'innerHTML',
        1
      ]

    ]
      ,[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      if (('click' === en)) {
        const pd_0:any = ((<any>v.parent.context.options.onConfirm({clickEvent: $event})) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
      import0.ɵdid(270336,(null as any),0,import2.FocusDirective,[import0.ElementRef],{mwlFocus: [
        0,
        'mwlFocus'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n              '])),
    (l()(),import0.ɵted((null as any),['\n            ']))
  ]
  ,(ck,v) => {
    const currVal_0:any = 'col-xs-6 col-6';
    const currVal_1:any = ck(v,2,0,v.parent.context.options.hideCancelButton);
    ck(v,1,0,currVal_0,currVal_1);
    const currVal_4:any = (v.parent.context.options.focusButton === 'confirm');
    ck(v,5,0,currVal_4);
  },(ck,v) => {
    const currVal_2:any = ('btn btn-block btn-' + v.parent.context.options.confirmButtonType);
    const currVal_3:any = v.parent.context.options.confirmText;
    ck(v,4,0,currVal_2,currVal_3);
  });
}
function View_ConfirmationPopoverWindowComponent_3(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),7,'div',[[
        'class',
        'col-xs-6 col-6'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    import0.ɵdid(139264,(null as any),0,import1.NgClass,[
      import0.IterableDiffers,
      import0.KeyValueDiffers,
      import0.ElementRef,
      import0.Renderer
    ]
    ,{
      klass: [
        0,
        'klass'
      ]
      ,
      ngClass: [
        1,
        'ngClass'
      ]

    }
    ,(null as any)),
    import0.ɵpod(['col-xs-offset-3 col-offset-3']),
    (l()(),import0.ɵted((null as any),['\n              '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),2,'button',[[
        'type',
        'button'
      ]
    ],[
      [
        8,
        'className',
        0
      ]
      ,
      [
        8,
        'innerHTML',
        1
      ]

    ]
      ,[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      if (('click' === en)) {
        const pd_0:any = ((<any>v.parent.context.options.onCancel({clickEvent: $event})) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
      import0.ɵdid(270336,(null as any),0,import2.FocusDirective,[import0.ElementRef],{mwlFocus: [
        0,
        'mwlFocus'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n              '])),
    (l()(),import0.ɵted((null as any),['\n            ']))
  ]
  ,(ck,v) => {
    const currVal_0:any = 'col-xs-6 col-6';
    const currVal_1:any = ck(v,2,0,v.parent.context.options.hideConfirmButton);
    ck(v,1,0,currVal_0,currVal_1);
    const currVal_4:any = (v.parent.context.options.focusButton === 'cancel');
    ck(v,5,0,currVal_4);
  },(ck,v) => {
    const currVal_2:any = ('btn btn-block btn-' + v.parent.context.options.cancelButtonType);
    const currVal_3:any = v.parent.context.options.cancelText;
    ck(v,4,0,currVal_2,currVal_3);
  });
}
function View_ConfirmationPopoverWindowComponent_1(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵted((null as any),['\n      '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),21,'div',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    import0.ɵdid(139264,(null as any),0,import1.NgClass,[
      import0.IterableDiffers,
      import0.KeyValueDiffers,
      import0.ElementRef,
      import0.Renderer
    ]
      ,{ngClass: [
        0,
        'ngClass'
      ]
    },(null as any)),
    import0.ɵpad(5),
    (l()(),import0.ɵted((null as any),['\n        '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),0,'div',[[
        'class',
        'popover-arrow arrow'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n        '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),0,'h3',[[
        'class',
        'popover-title popover-header'
      ]
      ],[[
        8,
        'innerHTML',
        1
      ]
    ],(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n        '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),12,'div',[[
        'class',
        'popover-content popover-body'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n          '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),0,'p',([] as any[]),[[
        8,
        'innerHTML',
        1
      ]
    ],(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n          '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),7,'div',[[
        'class',
        'row'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵand(8388608,(null as any),(null as any),1,(null as any),View_ConfirmationPopoverWindowComponent_2)),
    import0.ɵdid(8192,(null as any),0,import1.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵand(8388608,(null as any),(null as any),1,(null as any),View_ConfirmationPopoverWindowComponent_3)),
    import0.ɵdid(8192,(null as any),0,import1.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n          '])),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵted((null as any),['\n      '])),
    (l()(),import0.ɵted((null as any),['\n    ']))
  ]
  ,(ck,v) => {
    const currVal_0:any = ck(v,3,0,'popover',v.context.options.placement,('popover-' + v.context.options.placement),('bs-popover-' + v.context.options.placement),v.context.options.popoverClass);
    ck(v,2,0,currVal_0);
    const currVal_3:boolean = !v.context.options.hideConfirmButton;
    ck(v,16,0,currVal_3);
    const currVal_4:boolean = !v.context.options.hideCancelButton;
    ck(v,19,0,currVal_4);
  },(ck,v) => {
    const currVal_1:any = v.context.options.title;
    ck(v,7,0,currVal_1);
    const currVal_2:any = v.context.options.message;
    ck(v,11,0,currVal_2);
  });
}
function View_ConfirmationPopoverWindowComponent_4(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[(l()(),import0.ɵted((null as any),['\n    ']))],(null as any),(null as any));
}
export function View_ConfirmationPopoverWindowComponent_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵted((null as any),['\n    '])),
      (l()(),import0.ɵand(0,[[
        'defaultTemplate',
        2
      ]
    ],(null as any),0,(null as any),View_ConfirmationPopoverWindowComponent_1)),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵand(8388608,(null as any),(null as any),2,(null as any),View_ConfirmationPopoverWindowComponent_4)),
    import0.ɵdid(270336,(null as any),0,import1.NgTemplateOutlet,[import0.ViewContainerRef],{
      ngTemplateOutletContext: [
        0,
        'ngTemplateOutletContext'
      ]
      ,
      ngTemplateOutlet: [
        1,
        'ngTemplateOutlet'
      ]

    }
    ,(null as any)),
    import0.ɵpod(['options']),
    (l()(),import0.ɵted((null as any),['\n  ']))
  ]
  ,(ck,v) => {
    var co:import3.ConfirmationPopoverWindowComponent = v.component;
    const currVal_0:any = ck(v,5,0,co.options);
    const currVal_1:any = (co.options.customTemplate || import0.ɵnov(v,1));
    ck(v,4,0,currVal_0,currVal_1);
  },(null as any));
}
function View_ConfirmationPopoverWindowComponent_Host_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'ng-component',([] as any[]),(null as any),(null as any),(null as any),View_ConfirmationPopoverWindowComponent_0,RenderType_ConfirmationPopoverWindowComponent)),
    import0.ɵdid(2121728,(null as any),0,import3.ConfirmationPopoverWindowComponent,[import4.ConfirmationPopoverWindowOptions],(null as any),(null as any))
  ]
  ,(null as any),(null as any));
}
export const ConfirmationPopoverWindowComponentNgFactory:import0.ComponentFactory<import3.ConfirmationPopoverWindowComponent> = import0.ɵccf('ng-component',import3.ConfirmationPopoverWindowComponent,View_ConfirmationPopoverWindowComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/angular-router-loader/src?&aot=true&genDir=compiled!./~/tslint-loader!./compiled/~/angular-confirmation-popover/dist/esm/src/confirmation-popover-window.component.ngfactory.ts